/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties}
 */
 /* tslint:disable */


import * as import0 from '@angular/core';
import * as import1 from '@angular/common';
import * as import2 from 'angular-confirmation-popover/dist/esm/src/focus.directive';
import * as import3 from 'angular-confirmation-popover/dist/esm/src/confirmation-popover-window.component';
import * as import4 from 'angular-confirmation-popover/dist/esm/src/confirmation-popover-window-options.provider';
const styles_ConfirmationPopoverWindowComponent:any[] = ['.popover[_ngcontent-%COMP%] {\n      display: block;\n    }\n    .bs-popover-top[_ngcontent-%COMP%]   .arrow[_ngcontent-%COMP%], .bs-popover-bottom[_ngcontent-%COMP%]   .arrow[_ngcontent-%COMP%] {\n      left: 50%;\n    }\n    .bs-popover-left[_ngcontent-%COMP%]   .arrow[_ngcontent-%COMP%], .bs-popover-right[_ngcontent-%COMP%]   .arrow[_ngcontent-%COMP%] {\n      top: 50%;\n    }\n    .btn[_ngcontent-%COMP%] {\n      transition: none;\n    }'];
export const RenderType_ConfirmationPopoverWindowComponent:import0.RendererType2 = import0.ɵcrt({
  encapsulation: 0,
  styles: styles_ConfirmationPopoverWindowComponent,
  data: {}
}
);
function View_ConfirmationPopoverWindowComponent_2(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),7,'div',[[
        'class',
        'col-xs-6 col-6'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    import0.ɵdid(139264,(null as any),0,import1.NgClass,[
      import0.IterableDiffers,
      import0.KeyValueDiffers,
      import0.ElementRef,
      import0.Renderer
    ]
    ,{
      klass: [
        0,
        'klass'
      ]
      ,
      ngClass: [
        1,
        'ngClass'
      ]

    }
    ,(null as any)),
    import0.ɵpod(['col-xs-offset-3 col-offset-3']),
    (l()(),import0.ɵted((null as any),['\n              '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),2,'button',[[
        'type',
        'button'
      ]
    ],[
      [
        8,
        'className',
        0
      ]
      ,
      [
        8,
        'innerHTML',
        1
      ]

    ]
      ,[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      if (('click' === en)) {
        const pd_0:any = ((<any>v.parent.context.options.onConfirm({clickEvent: $event})) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
      import0.ɵdid(270336,(null as any),0,import2.FocusDirective,[import0.ElementRef],{mwlFocus: [
        0,
        'mwlFocus'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n              '])),
    (l()(),import0.ɵted((null as any),['\n            ']))
  ]
  ,(ck,v) => {
    const currVal_0:any = 'col-xs-6 col-6';
    const currVal_1:any = ck(v,2,0,v.parent.context.options.hideCancelButton);
    ck(v,1,0,currVal_0,currVal_1);
    const currVal_4:any = (v.parent.context.options.focusButton === 'confirm');
    ck(v,5,0,currVal_4);
  },(ck,v) => {
    const currVal_2:any = ('btn btn-block btn-' + v.parent.context.options.confirmButtonType);
    const currVal_3:any = v.parent.context.options.confirmText;
    ck(v,4,0,currVal_2,currVal_3);
  });
}
function View_ConfirmationPopoverWindowComponent_3(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),7,'div',[[
        'class',
        'col-xs-6 col-6'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    import0.ɵdid(139264,(null as any),0,import1.NgClass,[
      import0.IterableDiffers,
      import0.KeyValueDiffers,
      import0.ElementRef,
      import0.Renderer
    ]
    ,{
      klass: [
        0,
        'klass'
      ]
      ,
      ngClass: [
        1,
        'ngClass'
      ]

    }
    ,(null as any)),
    import0.ɵpod(['col-xs-offset-3 col-offset-3']),
    (l()(),import0.ɵted((null as any),['\n              '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),2,'button',[[
        'type',
        'button'
      ]
    ],[
      [
        8,
        'className',
        0
      ]
      ,
      [
        8,
        'innerHTML',
        1
      ]

    ]
      ,[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      if (('click' === en)) {
        const pd_0:any = ((<any>v.parent.context.options.onCancel({clickEvent: $event})) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
      import0.ɵdid(270336,(null as any),0,import2.FocusDirective,[import0.ElementRef],{mwlFocus: [
        0,
        'mwlFocus'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n              '])),
    (l()(),import0.ɵted((null as any),['\n            ']))
  ]
  ,(ck,v) => {
    const currVal_0:any = 'col-xs-6 col-6';
    const currVal_1:any = ck(v,2,0,v.parent.context.options.hideConfirmButton);
    ck(v,1,0,currVal_0,currVal_1);
    const currVal_4:any = (v.parent.context.options.focusButton === 'cancel');
    ck(v,5,0,currVal_4);
  },(ck,v) => {
    const currVal_2:any = ('btn btn-block btn-' + v.parent.context.options.cancelButtonType);
    const currVal_3:any = v.parent.context.options.cancelText;
    ck(v,4,0,currVal_2,currVal_3);
  });
}
function View_ConfirmationPopoverWindowComponent_1(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵted((null as any),['\n      '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),21,'div',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    import0.ɵdid(139264,(null as any),0,import1.NgClass,[
      import0.IterableDiffers,
      import0.KeyValueDiffers,
      import0.ElementRef,
      import0.Renderer
    ]
      ,{ngClass: [
        0,
        'ngClass'
      ]
    },(null as any)),
    import0.ɵpad(5),
    (l()(),import0.ɵted((null as any),['\n        '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),0,'div',[[
        'class',
        'popover-arrow arrow'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n        '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),0,'h3',[[
        'class',
        'popover-title popover-header'
      ]
      ],[[
        8,
        'innerHTML',
        1
      ]
    ],(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n        '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),12,'div',[[
        'class',
        'popover-content popover-body'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n          '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),0,'p',([] as any[]),[[
        8,
        'innerHTML',
        1
      ]
    ],(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n          '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),7,'div',[[
        'class',
        'row'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵand(8388608,(null as any),(null as any),1,(null as any),View_ConfirmationPopoverWindowComponent_2)),
    import0.ɵdid(8192,(null as any),0,import1.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵand(8388608,(null as any),(null as any),1,(null as any),View_ConfirmationPopoverWindowComponent_3)),
    import0.ɵdid(8192,(null as any),0,import1.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n          '])),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵted((null as any),['\n      '])),
    (l()(),import0.ɵted((null as any),['\n    ']))
  ]
  ,(ck,v) => {
    const currVal_0:any = ck(v,3,0,'popover',v.context.options.placement,('popover-' + v.context.options.placement),('bs-popover-' + v.context.options.placement),v.context.options.popoverClass);
    ck(v,2,0,currVal_0);
    const currVal_3:boolean = !v.context.options.hideConfirmButton;
    ck(v,16,0,currVal_3);
    const currVal_4:boolean = !v.context.options.hideCancelButton;
    ck(v,19,0,currVal_4);
  },(ck,v) => {
    const currVal_1:any = v.context.options.title;
    ck(v,7,0,currVal_1);
    const currVal_2:any = v.context.options.message;
    ck(v,11,0,currVal_2);
  });
}
function View_ConfirmationPopoverWindowComponent_4(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[(l()(),import0.ɵted((null as any),['\n    ']))],(null as any),(null as any));
}
export function View_ConfirmationPopoverWindowComponent_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵted((null as any),['\n    '])),
      (l()(),import0.ɵand(0,[[
        'defaultTemplate',
        2
      ]
    ],(null as any),0,(null as any),View_ConfirmationPopoverWindowComponent_1)),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵand(8388608,(null as any),(null as any),2,(null as any),View_ConfirmationPopoverWindowComponent_4)),
    import0.ɵdid(270336,(null as any),0,import1.NgTemplateOutlet,[import0.ViewContainerRef],{
      ngTemplateOutletContext: [
        0,
        'ngTemplateOutletContext'
      ]
      ,
      ngTemplateOutlet: [
        1,
        'ngTemplateOutlet'
      ]

    }
    ,(null as any)),
    import0.ɵpod(['options']),
    (l()(),import0.ɵted((null as any),['\n  ']))
  ]
  ,(ck,v) => {
    var co:import3.ConfirmationPopoverWindowComponent = v.component;
    const currVal_0:any = ck(v,5,0,co.options);
    const currVal_1:any = (co.options.customTemplate || import0.ɵnov(v,1));
    ck(v,4,0,currVal_0,currVal_1);
  },(null as any));
}
function View_ConfirmationPopoverWindowComponent_Host_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'ng-component',([] as any[]),(null as any),(null as any),(null as any),View_ConfirmationPopoverWindowComponent_0,RenderType_ConfirmationPopoverWindowComponent)),
    import0.ɵdid(2121728,(null as any),0,import3.ConfirmationPopoverWindowComponent,[import4.ConfirmationPopoverWindowOptions],(null as any),(null as any))
  ]
  ,(null as any),(null as any));
}
export const ConfirmationPopoverWindowComponentNgFactory:import0.ComponentFactory<import3.ConfirmationPopoverWindowComponent> = import0.ɵccf('ng-component',import3.ConfirmationPopoverWindowComponent,View_ConfirmationPopoverWindowComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/angular-router-loader/src?&aot=true&genDir=compiled!./~/tslint-loader!./compiled/~/angular-confirmation-popover/dist/esm/src/confirmation-popover-window.component.ngfactory.ts